/* Imports */
import React from "react"
import { Video } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const VideoPage = () => {
    const items = [
        {
            title: "With controls",
            content: <Video src="/images/video-html.mp4" />,
            code: '<Video src="/images/video-html.mp4" />',
        },
        {
            title: "With autoplay",
            content: <Video src="/images/video-html.mp4" autoPlay />,
            code: '<Video src="/images/video-html.mp4" autoPlay />',
        },
    ]
    
    const propsItems = [
        {
            name: "src",
            type: "String",
            example:
                "https://assets.mixkit.co/videos/preview/mixkit-top-aerial-shot-of-seashore-with-rocks-1090-large.mp4",
            required: "Yes",
        },
        {
            name: "autoPlay",
            type: "Boolean",
        },
        {
            name: "muted",
            type: "Boolean",
        },
        {
            name: "controls",
            type: "Boolean",
        },
        {
            name: "fit",
            type: "String",
            example: "contain",
            possible: commonProps.objectFit,
        },
        {
            name: "aspectRatio",
            type: "String",
            example: "16/9",
        },
        {
            name: "width",
            type: "String or Number",
            example: "60vw",
            default: "100%",
        },
        {
            name: "height",
            type: "String or Number",
            example: 400,
            default: "auto",
        },
        {
            name: "emptyText",
            type: "String",
            default: "Your browser doesn't support the video tag.",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default VideoPage
